<header>
   <div class="feedContainer">
      <div class="feedDetails">
         <span class="FeedTitle">All Feeds</span>
      </div>
      <div class="FeedButton">
         <button class="btn btn-primary" [routerLink]="['/feed/add',0]" color="primary">Create Post</button>
      </div>
    </div>
</header>

<div class="card-body">
   <div class="w-full">
      <div class="FeedContent">
         <div class="Feed1">
            <div class="posts-container" *ngFor="let feedItems of FeedDetails; let i = index">
               <div class="PostInner-Container">
                  <div class="Post">
                     <div class="content1">
                        <div class="content2">
                           <div class="post-card-content">
                              <div class="timeline-body">
                                 <div class="feed-date"> {{feedItems.Date | date : 'dd MMM yyyy'}}&nbsp;&nbsp;{{feedItems.CreatedTime}}</div>
                                 <div class="timeline-header">

                                    <span class="userimage"><img src="..\assets\UserProfileImage\EmpDefaultImage.jpg"></span>
                                    <span class="username"><a href="/">{{feedItems.EmployeeName}}</a> <small></small></span>
       
                                    <br>
                                    <span class="pull-left text-muted">#{{feedItems.EmpCode}}</span><br>
                                    <span class="pull-right text-muted">Group:Everyone</span><br>
                                    <span class="pull-right">  {{feedItems.Title}}</span>
                                 </div>
                                 <div class="timeline-content">
                                  
                                    <p>
                                       {{feedItems.Description}}
                                    </p>
                                 </div>
                                 <div class="timeline-likes">
                                    <div class="stats-right">
                                       <i class="bi bi-pencil-square" [routerLink]="['/feed/add',feedItems.ESS_PostMasterID]"></i>
                                    </div>
                                    <!-- <div class="stats">
                                       <span class="fa-stack fa-fw stats-icon">
                                          <i class="fa fa-circle fa-stack-2x text-danger"></i>
                                          <i class="fa fa-heart fa-stack-1x fa-inverse t-plus-1"></i>
                                       </span>
                                       <span class="fa-stack fa-fw stats-icon">
                                          <i class="fa fa-circle fa-stack-2x text-primary"></i>
                                          <i class="fa fa-thumbs-up fa-stack-1x fa-inverse"></i>
                                       </span>
                                       <span class="stats-total">{{feedItems.LikeCount}}</span>
                                    </div> -->
                                 </div>
                                 <!-- <div class="timeline-footer">
                                    <a class="m-r-15 text-inverse-lighter"> <svg
                                          xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                          class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                                          <path
                                             d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                                       </svg> Like</a>

                                    <a class="m-r-15 text-inverse-lighter"
                                       (click)="toggleCommentSection($event)"><svg xmlns="http://www.w3.org/2000/svg"
                                          width="16" height="16" fill="currentColor" class="bi bi-chat-text-fill"
                                          viewBox="0 0 16 16">
                                          <path
                                             d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z" />
                                       </svg> Comment</a>

                                 </div> -->
                                 <div class="timeline-comment-box" *ngIf="commentSectionVisible">
                                    <div class="user"><img src="..\assets\UserProfileImage\EmpDefaultImage.jpg">
                                    </div>
                                    <div class="input">
                                       <form action="">
                                          <div class="input-group">
                                             <input type="text" class="form-control rounded-corner"
                                                placeholder="Write a comment...">
                                             <span class="input-group-btn p-l-10">
                                                <button class="btn btn-primary f-s-12 rounded-corner"
                                                   type="button">Comment</button>
                                             </span>
                                          </div>
                                       </form>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         
         </div>
      </div>
   </div>
</div>